import { Empty } from "antd";
import Loader from "Components/Loader";
import { useGetMeQuery } from "hooks/Auth/useGetMeQuery";
import { useGetDriverOrdersQuery } from "hooks/Driver/useGetDriverOrdersQuery";
import { useGetMyOrdersQuery } from "hooks/Driver/useGetMyOrdersQuery";
import { useDebounce } from "hooks/useDebounce";
import DriverDashboard from "Layout/DriverDashboard";
import { Status } from "Pages/User/OrderManagement/Components/Status";
import { useState } from "react";
import Moment from "react-moment";
import { Link } from "react-router-dom";
import Pagination from "./Pagination";

const DriverOrder = () => {
  const boxes = require("../../../assets/boxes.png");
  const [search, setSearch] = useState("");
  const [page, setPage] = useState(1);
  const debouncedSearch = useDebounce(search, 500);
  const payload = {
    startDate: "",
    endDate: "",
    status: "",
    deliveryMethod: "",
    search: debouncedSearch,
  };
  const { data: ddd, isLoading: isLoadingOrders } =
    useGetMyOrdersQuery(payload);

  // const id = data?.data?.id;

  // const { data: orders, isLoading } = useGetDriverOrdersQuery({
  //   id: id || "",
  //   search: debouncedSearch,
  // });
  return (
    <DriverDashboard
      title="Orders"
      back={false}
      header={
        <div className="relative pb-4 shadow-sm">
          {search !== "" && (
            <button
              className="absolute right-[10px] top-[12px]"
              onClick={() => setSearch("")}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth={1.5}
                stroke="currentColor"
                className="size-6"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M6 18 18 6M6 6l12 12"
                />
              </svg>
            </button>
          )}
          <input
            type="search"
            name=""
            className="p-3 rounded-md bg-[#f9f9f9] w-full"
            placeholder="Search"
            value={search}
            onChange={(e) => setSearch(e?.target?.value)}
          />
        </div>
      }
    >
      <div>
        <div className="">
          {isLoadingOrders && <Loader />}
          {!isLoadingOrders &&
            ddd?.data?.docs &&
            ddd?.data?.docs.length === 0 && (
              <Empty description="No Order" className="my-[50px]" />
            )}
          {ddd?.data?.docs &&
            ddd?.data?.docs.map(
              ({
                id,
                orderStatus,
                orderNo,
                createdAt,
                customerAddress,
              }: {
                id: string;
                orderStatus: string;
                orderNo: string;
                createdAt: string;
                customerAddress: string;
              }) => (
                <Link
                  to={`/driver/orders/${id}`}
                  key={id}
                  className="flex flex-row gap-3 py-3 border-b-[1px] border-b-[#e4e4e4]"
                >
                  {/* <img
                    src={boxes}
                    className="h-[45px] w-[45px] bg-[#ddd] rounded-lg"
                    alt=""
                  /> */}
                  <Boxes />
                  <div className="flex-1">
                    <div>
                      <h3>{orderNo}</h3>
                      <p className="text-[13px]">{customerAddress}</p>
                      <Moment
                        interval={0}
                        format="DD-MM-YYYY hh:mm a"
                        className="text-[#939393] text-[13px]"
                      >
                        {createdAt}
                      </Moment>
                    </div>
                  </div>
                  <span className="w-[80px] flex justify-end text-[13px]">
                    <Status value={orderStatus} />
                  </span>
                </Link>
              )
            )}
          {ddd?.data?.meta?.page > 1 && (
            <Pagination
              paginationData={ddd?.data?.meta}
              onPageChange={setPage}
            />
          )}
          {/* {ddd?.data?.docs && ddd?.data?.docs.length > 10 && (
          )} */}
        </div>
      </div>
    </DriverDashboard>
  );
};

export default DriverOrder;

export const Boxes = () => {
  return (
    <svg
      width="45"
      height="45"
      viewBox="0 0 45 45"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="45" height="45" rx="10" fill="#F6F6F6" />
      <path
        d="M21.9922 11.6738C22.2422 11.5254 22.5469 11.5254 22.7891 11.6738L31.3203 16.8613C31.5234 16.9863 31.6484 17.2129 31.6484 17.4473L22.3906 23.6715L13.125 17.5246V17.4465C13.125 17.2121 13.25 16.9855 13.4531 16.8684L21.9922 11.6738Z"
        fill="#F3C07B"
      />
      <path
        d="M22.3875 22.6924L31.2625 17.3018C31.3014 17.2786 31.3458 17.2661 31.3911 17.2656C31.4364 17.2652 31.4809 17.2767 31.5205 17.2991C31.5598 17.3215 31.5925 17.3539 31.6153 17.3931C31.6381 17.4323 31.65 17.4768 31.65 17.5221V27.1627C31.6502 27.3949 31.5905 27.6231 31.477 27.8256C31.3634 28.0281 31.1997 28.198 31.0016 28.3189L22.6891 33.3658C22.6679 33.3775 22.6449 33.3853 22.6211 33.3892C22.6001 33.3955 22.5782 33.3985 22.5563 33.3978C22.4675 33.4227 22.3748 33.4297 22.2834 33.4186C22.1919 33.4075 22.1036 33.3785 22.0234 33.333H22.0281L20.1562 24.844L22.3875 22.6924Z"
        fill="#FFCE7C"
      />
      <path
        d="M22.3906 33.1427V22.6973L13.5234 17.3067C13.4843 17.2815 13.4391 17.2674 13.3925 17.2658C13.346 17.2642 13.2999 17.2751 13.2591 17.2975C13.2183 17.3199 13.1843 17.3529 13.1607 17.393C13.1371 17.4332 13.1248 17.4789 13.125 17.5255V27.1661C13.125 27.6427 13.375 28.0802 13.7734 28.3224L22.0313 33.338C22.0665 33.3602 22.107 33.3727 22.1487 33.3739C22.1903 33.3753 22.2316 33.3655 22.2682 33.3456C22.3048 33.3258 22.3354 33.2964 22.357 33.2608C22.3785 33.225 22.3901 33.1842 22.3906 33.1427Z"
        fill="#E19747"
      />
      <path
        d="M21.3281 30.9218V29.3905C21.3281 29.2108 21.2344 29.0468 21.0859 28.953L18.8984 27.6327C18.75 27.5468 18.5625 27.6483 18.5625 27.8202V29.3514C18.5625 29.5311 18.6563 29.6952 18.8047 29.7889L20.9922 31.1093C21.1406 31.1952 21.3281 31.0936 21.3281 30.9218Z"
        fill="#D3D3D3"
      />
      <path
        d="M19.188 22.9324V19.3691L16.6255 19.1973V21.666C16.6255 21.7441 16.6646 21.8223 16.7349 21.8691L18.8286 23.1426C18.9849 23.2285 19.188 23.1199 19.188 22.9324Z"
        fill="#8C5543"
      />
      <path
        d="M25.8911 13.5645L16.6255 19.1973L19.188 20.7598L28.4536 15.1348L25.8911 13.5645Z"
        fill="#A56953"
      />
    </svg>
  );
};
